import { SuccessPayload } from 'components/widgets/invest-component/storage/invest-states'

type ApproveTransactionResult = {
  hash: string
  params: SuccessPayload
}

export const parseApproveTransactionResult = (
  hash: string,
  params: SuccessPayload,
): ApproveTransactionResult => {
  return {
    hash,
    params,
  }
}
